import Honeybadger from "@honeybadger-io/js";
import { stripSensitiveQueryParams } from "./strip_sensitive_query_params";
import { ignorableNotice } from "./ignorable_notice";

const NON_REPORTING_ENVIRONMENTS = ["development", "test", "cucumber"];

function meta(name) {
  return document.querySelector(`meta[name="${name}"]`)?.content || null;
}

const apiKey = meta("hb-api-key");
const environment = meta("hb-environment");
const revision = meta("hb-revision");

if (apiKey && environment) {
  Honeybadger.configure({
    apiKey,
    environment,
    revision,
    reportData: !NON_REPORTING_ENVIRONMENTS.includes(environment),
    breadcrumbsEnabled: true,
    enableUncaught: true,
    enableUnhandledRejection: true,
    filters: ["password", "token", "email", "magic_link_token", "api_key", "credit_card"]
  });

  Honeybadger.beforeNotify((notice) => {
    // Drop noise that isn't an app bug: cancelled Turbo fetches and errors
    // raised by scripts injected by in-app browsers or browser extensions
    // (see ignorable_notice.js).
    if (ignorableNotice(notice)) {
      return false;
    }

    if (notice && notice.url) {
      notice.url = stripSensitiveQueryParams(notice.url);
    }
  });

  Honeybadger.setContext({
    user_id: meta("hb-user-id"),
    user_role: meta("hb-user-role"),
    order_id: meta("hb-order-id"),
    session_id: meta("hb-session-id")
  });
}

export default Honeybadger;
